import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=5e7d95de&scoped=true"
import script from "./retention.vue?vue&type=script&lang=js"
export * from "./retention.vue?vue&type=script&lang=js"
import style0 from "./retention.vue?vue&type=style&index=0&id=5e7d95de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d95de",
  null
  
)

export default component.exports